module.exports = __webpack_public_path__ + "static/media/ecosystem.b88dc25f.png";